import React from "react";
import { Link } from "react-router-dom";
import { Container, Header, Button } from "semantic-ui-react";

const NotFound = () => {
  // 상단 fixed 메뉴에 가리지 않게 padding — 다른 페이지와 동일 패턴.
  return (
    <Container style={{ padding: "6em 0em", textAlign: "center" }}>
      <Header as="h1">요청하신 페이지를 찾을 수 없습니다.</Header>
      <Button as={Link} to="/" primary>
        홈으로
      </Button>
    </Container>
  );
};

export default NotFound;
